// 得分计算函数
import type { ChessType } from "@/store/game"
import { BOARD_SIZE } from "@/store/game"
import { GAME_KOMI } from "@/const/game"

/**
 * 计算游戏得分和胜负
 * 得分规则：得分 = 场上棋子数 + 提子数，白棋的得分还要加上让目数（Komi）
 * 得分多的一方获胜，相等时判黑棋胜
 * 
 * @param board 棋盘状态
 * @param blackCaptures 黑棋提子数（黑棋吃掉的白子数）
 * @param whiteCaptures 白棋提子数（白棋吃掉的黑子数）
 * @returns 返回胜负、得分差以及双方得分
 */
export function calculateScore(
    board: ChessType[][],
    blackCaptures: number,
    whiteCaptures: number
): {
    winner: "black" | "white" | null
    diff: number // 正数表示黑棋得分多 diff 分，负数表示白棋得分多 |diff| 分
    blackScore: number // 黑棋得分
    whiteScore: number // 白棋得分（已包含让目数）
} {
    // 统计场上棋子数量
    let blackStones = 0
    let whiteStones = 0

    for (let row = 0; row < BOARD_SIZE; row++) {
        for (let col = 0; col < BOARD_SIZE; col++) {
            const stone = board[row][col]
            if (stone === "black") {
                blackStones++
            } else if (stone === "white") {
                whiteStones++
            }
        }
    }

    // 计算得分：场上棋子数 + 提子数，白棋还要加上让目数
    const blackScore = blackStones + blackCaptures
    const whiteScore = whiteStones + whiteCaptures + GAME_KOMI

    // 计算得分差（正数表示黑棋得分多，负数表示白棋得分多）
    const diff = blackScore - whiteScore

    // 判断胜负：得分多的一方获胜，相等时判黑棋胜
    let winner: "black" | "white" | null = null
    if (diff >= 0) {
        winner = "black"
    } else {
        winner = "white"
    }

    return {
        winner,
        diff,
        blackScore,
        whiteScore,
    }
}
